import { render } from "./ItemSalesModifiersReport.vue?vue&type=template&id=0aabab65&scoped=true"
import script from "./ItemSalesModifiersReport.vue?vue&type=script&lang=js"
export * from "./ItemSalesModifiersReport.vue?vue&type=script&lang=js"

import "./ItemSalesModifiersReport.vue?vue&type=style&index=0&id=0aabab65&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aabab65"]])

export default __exports__